export const events = {
  viewRequests: 'Salary Advance - View requests',
  viewEmployees: 'Salary Advance - View employees',
  viewSummary: 'Salary Advance - View summary',
  viewSettings: 'Salary Advance - View settings',
  employeesOpenMissingInfoSidepanel: 'Salary Advance - Open missing info sidepanel',
  employeesClickMissingInfoLink: 'Salary Advance - Click missing info link',
  employeesToggleStatusSubmit: 'Salary Advance - Toggle employee status submit',
  employeesToggleStatusResult: 'Salary Advance - Toggle employee status result',
  summaryExportOpened: 'Salary Advance - Export opened',
  settingsSaveResult: 'Salary Advance - Settings save result',
}
